import { createSlice } from '@reduxjs/toolkit';
import { collection, addDoc, updateDoc, doc } from 'firebase/firestore';
import { db } from '../../firebaseConfig';

const initialState = {
  tickets: [],
  loading: false,
  error: null,
};

const ticketsSlice = createSlice({
  name: 'tickets',
  initialState,
  reducers: {
    setTickets: (state, action) => {
      state.tickets = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setTickets, setLoading, setError } = ticketsSlice.actions;

// Thunk action creator for creating a ticket
export const createTicket = (ticketData) => async (dispatch, getState) => {
  try {
    dispatch(setLoading(true));
    const docRef = await addDoc(collection(db, 'tickets'), {
      ...ticketData,
      createdAt: new Date(),
      updatedAt: new Date(),
    });
    const newTicket = { id: docRef.id, ...ticketData };
    const currentTickets = getState().tickets.tickets;
    dispatch(setTickets([...currentTickets, newTicket]));
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setError(error.message));
    dispatch(setLoading(false));
    throw error;
  }
};

// Thunk action creator for updating a ticket
export const updateTicket =
  (ticketId, ticketData) => async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const ticketRef = doc(db, 'tickets', ticketId);
      await updateDoc(ticketRef, {
        ...ticketData,
        updatedAt: new Date(),
      });
      const currentTickets = getState().tickets.tickets;
      const updatedTickets = currentTickets.map((ticket) =>
        ticket.id === ticketId ? { ...ticket, ...ticketData } : ticket
      );
      dispatch(setTickets(updatedTickets));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setError(error.message));
      dispatch(setLoading(false));
      throw error;
    }
  };

export default ticketsSlice.reducer;
